/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export const GiftCardStockStatus = {
    onDemand: "onDemand",
    stock: "stock"
} as const

export type GiftCardStockDto = {
    id: number;
    value: number;
    stock: number | null;
    status: string;
    expirationDate: string;
    barcode: string | null;
    isActive: boolean;
};


export type GiftCardStockRow = {
    giftcardId: number
    stockId: number
    imageUrl: string
    name: string
    barcode: string
    value: number
    expirationDate: string
    status: string,
    address: string;
}

export type PaginatedGiftCardStockDto = {
    items: GiftCardStockRow[];
    pages: number;
    currentPage: number;
    totalItems: number;
};
